import { render, staticRenderFns } from "./AssignClassRoom.vue?vue&type=template&id=05e1a143&scoped=true&"
import script from "./AssignClassRoom.vue?vue&type=script&lang=js&"
export * from "./AssignClassRoom.vue?vue&type=script&lang=js&"
import style0 from "./AssignClassRoom.vue?vue&type=style&index=0&id=05e1a143&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e1a143",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAutocomplete,VBtn,VCard,VCardActions,VCardText,VChip,VDialog,VDivider,VIcon,VProgressCircular})
